import React from 'react'

import styled from '@emotion/styled'

import { Grid, Text } from '@cash-design-system/react'

export interface AddressInformation {
  address: string
  apartmentNumber?: string
  city: string
  state: string
  zip: string
  tooltip?: React.ReactNode
}

const ShippingAddressContainer = styled.div`
  background: ${props => props.theme.colors.secondaryBackground};
  border-radius: 1.5rem;
  padding: ${props => props.theme.spacing.l};
`

export const ShippingAddress: React.FC<AddressInformation> = ({
  address,
  apartmentNumber,
  city,
  state,
  zip,
  tooltip,
}) => {
  const apartmentNum = apartmentNumber ? ` ${apartmentNumber}` : ''
  const addressStr = `${address}${apartmentNum}, ${city}, ${state} ${zip}`

  return (
    <ShippingAddressContainer>
      <Grid gap="xxs">
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <Text typography="labelMedium">Shipping Address</Text>
        <Grid gap="xs">
          <span data-testid="review-address">{addressStr}</span>
          {tooltip}
        </Grid>
      </Grid>
    </ShippingAddressContainer>
  )
}

export default ShippingAddress
